export default __webpack_public_path__ + "static/media/imglogin.870c1def.png";